"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterFacilityAdministratorAccountDto = instanceOfRegisterFacilityAdministratorAccountDto;
exports.RegisterFacilityAdministratorAccountDtoFromJSON = RegisterFacilityAdministratorAccountDtoFromJSON;
exports.RegisterFacilityAdministratorAccountDtoFromJSONTyped = RegisterFacilityAdministratorAccountDtoFromJSONTyped;
exports.RegisterFacilityAdministratorAccountDtoToJSON = RegisterFacilityAdministratorAccountDtoToJSON;
exports.RegisterFacilityAdministratorAccountDtoToJSONTyped = RegisterFacilityAdministratorAccountDtoToJSONTyped;
const PhoneNumberCreateDto_1 = require("./PhoneNumberCreateDto");
/**
 * Check if a given object implements the RegisterFacilityAdministratorAccountDto interface.
 */
function instanceOfRegisterFacilityAdministratorAccountDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function RegisterFacilityAdministratorAccountDtoFromJSON(json) {
    return RegisterFacilityAdministratorAccountDtoFromJSONTyped(json, false);
}
function RegisterFacilityAdministratorAccountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoFromJSON)(json['phoneNumber']),
    };
}
function RegisterFacilityAdministratorAccountDtoToJSON(json) {
    return RegisterFacilityAdministratorAccountDtoToJSONTyped(json, false);
}
function RegisterFacilityAdministratorAccountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoToJSON)(value['phoneNumber']),
    };
}
//# sourceMappingURL=RegisterFacilityAdministratorAccountDto.js.map